import React, { useState } from "react";
import { HiCheck } from "react-icons/hi";

export default function OneCheckBox({ title, callBack , style }) {
  const [isCheck, setIsCheck] = useState(false);
  return (
    <div
    style={style ? style : null}
      className="box-one-check-box"
      onClick={() => {
        callBack(isCheck);
        setIsCheck(!isCheck);
      }}
    >
      <div
        id={isCheck ? "one-check-box-has-checked" : ""}
        className="one-check-box-checked"
      >
        <HiCheck color="white" size={"0.7rem"} />
      </div>
      <p className="txt-main-content4">{title}</p>
    </div>
  );
}
